import React, { useState, useContext } from "react";

import { Link } from 'react-router-dom'
import Swal from 'sweetalert2';
import { useHistory, withRouter } from "react-router-dom"
import { AuthContext } from '../../context/AuthContext';
import { useTranslation, withTranslation, Trans } from 'react-i18next';

const LoginArea = (props) => {
    const { t, i18n } = useTranslation();
    const history = useHistory()
  // Login
  const { login, register } = useContext(AuthContext)
  // local
  var [isLoading, setIsLoading] = useState(false);
  var [errorMessage, setErrorMessage] = useState(null);
  var [activeTabId, setActiveTabId] = useState(0);
  var [nameValue, setNameValue] = useState("");
  var [emailValue, setEmailValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");
  const handleLogin = () => {
    login(
      emailValue,
      passwordValue,
      history,
      setIsLoading,
      setErrorMessage
    )
  }
   // Login
//    const login1 = () => {
//     if(status){
//         Swal.fire({
//             icon: 'question',
//             title: 'Mr. '+user.name,
//             html:
//                 'You are already loged in <br />' +
//                 'You can go to <b>' +
//                 'Dashboard</b> ' +
//                 'or our <b>Shop</b> page',
//         }).then((result) => {
//             if(result.isConfirmed) {
//               history.push('/my-account')
//             } else {
//               // not clicked
//             }
//           });
//     }else{
//         dispatch({ type: "user/login" })
//         let name = user.name || 'Customer'
//         console.log(typeof(user.name));
//         Swal.fire({
//             icon: 'success',
//             title: 'Login Sucessfull',
//             text: 'Welcome '+ name
//         })
//         history.push("/my-account");
//     }
    

// }
    return (
        <>
            <section id="login_area" className="ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                            <div className="account_form">
                                <h3>{t('login')}</h3>
                                <form onSubmit={(e)=>{e.preventDefault();handleLogin()}}>
                                    <div className="default-form-box">
                                        <label>{t('email')}<span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" required value={emailValue}
                  onChange={e => setEmailValue(e.target.value)}/>
                                    </div>
                                    <div className="default-form-box">
                                        <label>{t('pass')}<span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" required value={passwordValue}
                  onChange={e => setPasswordValue(e.target.value)} minLength="5"/>
                                    </div>
                                    
                                    <div className="login_submit">
                                    
                                        <button  className="theme-btn-one btn-black-overlay btn_md" type="submit">
                                        {isLoading? <div className="spinner-border text-light spinner-border-sm mr-2" role="status">
                                            <span className="sr-only">{t('loading')}...</span> 
                                            </div>:''} {isLoading? t('signingin'): t('signin')}
                                    </button>
                                    </div>
                                    <div className="remember_area">
                                        <div className="form-check">
                                            {/* <input type="checkbox" className="form-check-input" id="materialUnchecked"/>
                                            <label className="form-check-label" htmlFor="materialUnchecked">Remember me</label> */}
                                        </div>
                                    </div>
                                    <Link to="/register" className="active">{t('createacc')}</Link>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


export default withRouter(LoginArea);
